import React from "react";
import { useTranslation } from "react-i18next";
import { IconTextBkav } from "../../../assets/icon";
import "../../../assets/style/header.scss";
const Header = () => {
  const { t } = useTranslation();

  return (
    <div className="wrapperHeader ">
      <IconTextBkav width={215} height={74} />
      <p className="titleMenu">{t("Customer Connection Platform")}</p>
    </div>
  );
};

export default Header;
